import React from 'react';
import { staticConfig } from '../../../config/static';
// Styles
import styles from './tokendebug.module.scss';

interface ITokenDebugProps {
    token: string;
}

export const TokenDebug = (props: ITokenDebugProps): JSX.Element => {
    return (
        <>
            <div className={[styles.viewerWrap, 'd-flex flex-column w-100 align-items-center'].join(' ')}>
                <pre>{props.token}</pre>
                <a href={staticConfig.appBaseUrl}>
                    <p>To Mailbox</p>
                </a>
            </div>
        </>
    );
};
